"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonSpan = exports.Container = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../styles/constant");
var _styledSystem = require("styled-system");
var _templateObject, _templateObject2;
const styledShape = (0, _styledSystem.variant)({
  prop: 'variant',
  variants: {
    circular: {
      borderRadius: '50%'
    },
    rectangular: {
      borderRadius: '0.rem'
    },
    rounded: {
      borderRadius: '0.25rem'
    }
  }
});
const styledAnimation = (0, _styledSystem.variant)({
  prop: 'animation',
  variants: {
    waive: {
      backgroundRepeat: 'no-repeat',
      backgroundImage: "linear-gradient(\n      90deg,\n      var(--base-color),\n      var(--highlight-color),\n      var(--base-color)\n    )",
      transform: 'translateX(-100%)',
      animationName: 'anchorWaiveskeletonLoader'
    },
    pulse: {
      backgroundRepeat: '',
      backgroundImage: '',
      transform: '',
      animationName: 'anchorPulseSkeletonLoader'
    }
  }
});
const variants = {
  styledShape,
  styledAnimation
};
const SkeletonSpan = exports.SkeletonSpan = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  @keyframes anchorWaiveskeletonLoader {\n    100% {\n      transform: translateX(100%);\n    }\n  }\n  @keyframes anchorPulseSkeletonLoader {\n    0% {\n      background-color: var(--base-color);\n    }\n    100% {\n      background-color: var(--highlight-color);\n    }\n  }\n\n  --base-color: ", ";\n  --highlight-color: ", ";\n  --animation-duration: 1500ms;\n  --animation-direction: normal;\n  --pseudo-element-display: block; /* Enable animation */\n\n  background-color: var(--base-color);\n\n  ", "\n  width: 100%;\n  display: inline-flex;\n  line-height: 1;\n\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  &:after {\n    content: ' ';\n    display: var(--pseudo-element-display);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 100%;\n    ", "\n    animation-direction:", ";\n    animation-duration: var(--animation-duration);\n    animation-timing-function: ease-in-out;\n    animation-iteration-count: infinite;\n  }\n"])), (0, _constant.get)('colors.functional.grey.200'), (0, _constant.get)('colors.functional.grey.100'), variants.styledShape, variants.styledAnimation, props => props.animation === 'pulse' ? 'alternate' : 'var(--animation-direction)');
const Container = exports.Container = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])([""])));